import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { initObservability } from './utils/observability';
// i18n bootstrap (2026-05-15) — Option B: LandingPage + Navbar in RO/EN
import './i18n';

initObservability();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);

// Service Worker — cache-first pentru assets, cache 5min pentru /api/public/*.
// Reduce dramatic timpii de load la vizite ulterioare. Inregistrat dupa load
// pentru a nu bloca initial paint.
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      // Silent fail — SW e enhancement, nu critical
      if (process.env.NODE_ENV !== 'production') console.warn('SW registration failed:', err);
    });
  });
}
